import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/nfse/cooperado/';

class CooperadoService {
    constructor() {
        LoginService.currentUser.subscribe(data => {
            this.headers = {
                'Content-Type':'application/json',
                'authorization':'Bearer ' + (data ? data.token:'')
            };
        });
    }
    
    findAllCooperado(idContribuinte, filtro){
        return axios.get(API_URL + 'filterContribuinte?idContribuinte='+idContribuinte+'&filtro='+filtro,{headers: this.headers});
    }

    get(cooperadoId) {
        return axios.get(API_URL+cooperadoId, {headers: this.headers});
    }

    saveCooperado(cooperado){
        return axios.post(API_URL + 'saveCooperado', JSON.stringify(cooperado), {headers: this.headers});
    }

    delete(cooperadoId) {
        return axios.delete(API_URL+cooperadoId, {headers: this.headers});
    }


}

export default new CooperadoService();